import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IHerausgebersResponse } from 'fa-kt.types';
import { PostHerausgeberCommandService } from '../commands';
import { HerausgebersService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class HerausgebersPageResolver implements Resolve<IHerausgebersResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private herausgebers: HerausgebersService,
    private postHerausgeber: PostHerausgeberCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IHerausgebersResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [herausgebers] = await Promise.all([this.herausgebers.request({}).catch(log), this.postHerausgeber.prepare(true).catch(log)]);
    this.loading.resolved();
    return herausgebers;
  }
}
